<template>
    <!-- Новий дизайн: «Скільки піци на компанію». Люди × апетит дають грами, грами — кількість піц за середньою вагою
         обраного розміру. Набір складаємо з меню різним, кожну піцу можна замінити; «Додати в кошик» кладе всі одразу -->
    <div class="bp-rnd bp-ingf bp-crowd" role="dialog" aria-modal="true" aria-labelledby="bp-crowd-title" @keydown.esc="$emit('close')">
        <div class="bp-rnd__overlay" @click="$emit('close')"></div>
        <div class="bp-ingf__box" ref="box" tabindex="-1">
            <div class="bp-ingf__head">
                <h2 class="bp-ingf__title" id="bp-crowd-title">Скільки піци на компанію</h2>
                <button type="button" class="bp-rnd__x" aria-label="Закрити" @click="$emit('close')" v-html="icons.close"></button>
            </div>
            <div class="bp-ingf__body">
                <div class="bp-crowd__field">
                    <span class="bp-crowd__label" id="bp-crowd-people">Скільки вас</span>
                    <div class="bp-crowd__step" role="group" aria-labelledby="bp-crowd-people">
                        <button type="button" aria-label="Менше людей" :disabled="people <= MIN" @click="setPeople(people - 1)" v-html="icons.minus"></button>
                        <output aria-live="polite">{{ people }}</output>
                        <button type="button" aria-label="Більше людей" :disabled="people >= MAX" @click="setPeople(people + 1)" v-html="icons.plus"></button>
                    </div>
                </div>
                <div class="bp-crowd__field">
                    <span class="bp-crowd__label" id="bp-crowd-hunger">Апетит</span>
                    <div class="bp-size bp-crowd__seg bp-crowd__seg--3" role="group" aria-labelledby="bp-crowd-hunger">
                        <button v-for="item in HUNGER" :key="item.key" type="button" :aria-pressed="hunger == item.key ? 'true' : 'false'"
                                @click="hunger = item.key">{{ item.label }}</button>
                    </div>
                </div>
                <div class="bp-crowd__field" v-if="sizes.length > 1">
                    <span class="bp-crowd__label" id="bp-crowd-size">Розмір</span>
                    <div class="bp-size bp-crowd__seg" role="group" aria-labelledby="bp-crowd-size">
                        <button v-for="item in sizes" :key="item" type="button" :aria-pressed="size == item ? 'true' : 'false'"
                                @click="size = item">{{ item }} см</button>
                    </div>
                </div>

                <div class="bp-crowd__sum">
                    <p class="bp-crowd__count" aria-live="polite">
                        {{ set.length }} {{ pizzasWord(set.length) }} по {{ size }} см
                        <span class="bp-crowd__per">≈ {{ perPerson }} г на кожного</span>
                    </p>
                    <button type="button" class="bp-crowd__shuffle" @click="build()"><span class="bp-rnd__ic" v-html="icons.dice"></span>Інший набір</button>
                </div>
                <ul class="bp-crowd__list">
                    <li v-for="(pizza, i) in set" :key="i + '-' + pizza.id" class="bp-crowd__item">
                        <img :src="photo(pizza)" alt="" class="bp-crowd__img" :class="{ 'bp-nophoto': noPhoto(pizza) }">
                        <span class="bp-crowd__name"><b v-html="pizza.title"></b><small>{{ pizza['weight_' + size] }} г</small></span>
                        <span class="bp-crowd__price">{{ price(pizza) }} грн</span>
                        <button type="button" class="bp-crowd__swap" :aria-label="'Замінити ' + plain(pizza.title)" title="Замінити"
                                @click="swap(i)" v-html="icons.refresh"></button>
                    </li>
                </ul>
                <p class="bp-crowd__promo" v-if="promo"><span class="bp-crowd__promo-ic" v-html="icons.gift"></span>{{ promo }}</p>
            </div>
            <div class="bp-ingf__foot bp-crowd__foot">
                <button type="button" class="bp-rnd__order" :class="{ 'is-done': done }" :disabled="!set.length" @click="add()">
                    <template v-if="done"><span class="bp-crowd__ok" v-html="icons.check"></span>Додано в кошик</template>
                    <template v-else>Додати в кошик · {{ total }} грн</template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import { pizzasWord } from '@/ingredientGroups'
import { isHot, isVeg, isSea } from '@/pizzaKinds'

const PIZZA_MOCK = (process.env.BASE_URL || '/') + 'img/pizza-nophoto.webp';
const MIN = 1;
const MAX = 30;
// Грамів піци на людину: 30 см важить ~600 г — це «поїсти» на двох
const HUNGER = [
    { key: 'light', label: 'Перекусити', grams: 200 },
    { key: 'norm', label: 'Поїсти', grams: 300 },
    { key: 'hungry', label: 'Голодні', grams: 420 }
];
const shuffle = list => list.map(v => [Math.random(), v]).sort((a, b) => a[0] - b[0]).map(p => p[1]);
const median = list => {
    const s = list.slice().sort((a, b) => a - b);
    return s.length ? (s.length % 2 ? s[(s.length - 1) / 2] : (s[s.length / 2 - 1] + s[s.length / 2]) / 2) : 0;
};

export default {
    name: 'BpCrowdPizza',
    props: {
        // Усі піци меню міста (без пошуку й фільтрів)
        pizzas: { type: Array, required: true }
    },
    data() {
        return {
            icons: ICONS,
            MIN,
            MAX,
            HUNGER,
            people: 4,
            hunger: 'norm',
            size: 30,
            set: [],
            done: false,
            timer: null
        }
    },
    computed: {
        // Піци, які є в цьому розмірі: показані на сайті, з ціною й вагою
        pool() {
            const size = this.size;
            return this.pizzas.filter(p => p['show_' + size] == 1 && Number(p['price_' + size]) > 0 && Number(p['weight_' + size]) > 0);
        },
        sizes() {
            return [30, 50].filter(size => this.pizzas.some(p => p['show_' + size] == 1 && Number(p['price_' + size]) > 0 && Number(p['weight_' + size]) > 0));
        },
        avg() {
            return median(this.pool.map(p => Number(p['weight_' + this.size])));
        },
        // Скільки піц: потрібні грами на середню вагу піци цього розміру; 10 % недобору не варті ще однієї піци
        count() {
            const grams = HUNGER.find(item => item.key == this.hunger).grams * this.people;
            return this.avg ? Math.max(1, Math.ceil(grams / this.avg - 0.1)) : 0;
        },
        perPerson() {
            const sum = this.set.reduce((total, p) => total + Number(p['weight_' + this.size]), 0);
            return Math.round(sum / this.people / 10) * 10;
        },
        total() {
            return this.set.reduce((total, p) => total + this.price(p), 0);
        },
        // Акції кошика (Cart.vue): 2–3 піци — напій у подарунок, з 4 — 50 % на кожну 4-ту
        promo() {
            const n = this.set.length;
            if (n == 2 || n == 3) return 'За 2 або 3 піци — 1 л напою у подарунок';
            if (n >= 8) return 'Кожна 4-та піца — за пів ціни';
            if (n >= 4) return '4-та піца — за пів ціни';
            return '';
        }
    },
    watch: {
        count() {
            this.fit();
        },
        size() {
            this.fit();
        }
    },
    mounted() {
        document.querySelector('body').style.overflow = 'hidden';
        this.$refs.box.focus();
        if (!this.sizes.includes(this.size) && this.sizes.length) this.size = this.sizes[0];
        this.build();
    },
    beforeDestroy() {
        clearTimeout(this.timer);
        document.querySelector('body').style.overflow = '';
    },
    methods: {
        pizzasWord,
        plain(title) {
            return String(title || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
        },
        photo(pizza) {
            return this.noPhoto(pizza) ? PIZZA_MOCK : pizza.thumbnail;
        },
        noPhoto(pizza) {
            return /placeholder/i.test(pizza.thumbnail || '');
        },
        price(pizza) {
            return Number(pizza['price_' + this.size]);
        },
        setPeople(value) {
            this.people = Math.min(MAX, Math.max(MIN, value));
        },
        // Різний набір: гострих — не більше третини, морепродукти — одна й лише з 4 піц, з 3 піц — хоч одна вегетаріанська
        fits(pizza, others, n) {
            if (isHot(pizza) && others.filter(isHot).length >= Math.floor(n / 3)) return false;
            if (isSea(pizza) && others.filter(isSea).length >= (n >= 4 ? 1 : 0)) return false;
            return true;
        },
        // Випадковий порядок, але спершу піци звичайної ваги: з легкими (Маргарита 440 г при середніх 600) набір недобирав грамів
        shuffled(list) {
            const typical = p => Number(p['weight_' + this.size]) >= this.avg * 0.85;
            return shuffle(list.filter(typical)).concat(shuffle(list.filter(p => !typical(p))));
        },
        // Доповнює набір до count; спершу правила, далі будь-яка ще не взята, а коли піц у меню замало — повтори
        fill(keep) {
            const n = this.count;
            const set = [];
            keep.forEach(p => { if (set.length < n && this.fits(p, set, n)) set.push(p); });
            const pool = this.shuffled(this.pool);
            if (n >= 3 && !set.some(isVeg)) {
                const veg = pool.find(p => isVeg(p) && !set.includes(p));
                if (veg) set.length >= n ? set.splice(n - 1, 1, veg) : set.push(veg);
            }
            pool.forEach(p => { if (set.length < n && !set.includes(p) && this.fits(p, set, n)) set.push(p); });
            pool.forEach(p => { if (set.length < n && !set.includes(p)) set.push(p); });
            while (set.length < n && pool.length) set.push(pool[set.length % pool.length]);
            // Порядок — як у меню
            const order = this.pizzas;
            return set.sort((a, b) => order.indexOf(a) - order.indexOf(b));
        },
        build() {
            this.set = this.fill([]);
        },
        // Змінилась кількість чи розмір — лишаємо вже вибрані піци, що є в цьому розмірі
        fit() {
            this.set = this.fill(this.set.filter(p => this.pool.includes(p)));
        },
        swap(i) {
            const n = this.set.length;
            const others = this.set.filter((_, k) => k !== i);
            const needVeg = n >= 3 && isVeg(this.set[i]) && !others.some(isVeg);
            const free = this.shuffled(this.pool.filter(p => !this.set.includes(p)));
            const next = free.find(p => (!needVeg || isVeg(p)) && this.fits(p, others, n)) || free[0];
            if (next) this.$set(this.set, i, next);
        },
        // Як «В кошик» у вікні піци (AddToCart.vue): копія товару з розміром, ціною й порожніми додатками
        add() {
            if (this.done) return;
            const size = this.size;
            this.set.forEach(pizza => {
                const item = JSON.parse(JSON.stringify(pizza));
                item.quanity = 1;
                item.size = size + ' см';
                item.additionaIngredients = [];
                item.price = this.price(pizza);
                item.priceWithoutAdditionals = item.price;
                this.$store.commit('addToCart', item);
            });
            if (window.dataLayer) window.dataLayer.push({ event: 'addToCart' });
            this.done = true;
            this.timer = setTimeout(() => this.$emit('close'), 1000);
        }
    }
}
</script>
